import * as yup from "yup"

const message = "Campo Obrigatório";

export const contactSchema = yup.object({
  id: yup
    .string()
    .notRequired(),
  name: yup
    .string()
    .required( message ),
  ddi: yup.object().shape({
    name: yup.string().required(),
    code: yup.string().required(),
    iso: yup.string().length(2).required(),
    mask: yup
      .mixed()
      .test('is-string-or-array', 'Mask must be a string or array of strings', (value) => {
        if (typeof value === 'string') return true;
        if (Array.isArray(value)) return value.every((v) => typeof v === 'string');
        return false;
      })
      .required(),
  }),
  phone: yup
    .string()
    .required( message ),
});

export type ContactForm = yup.InferType<typeof contactSchema>;
